<form [formGroup]="myForm" class="transfer-dialog">
  <div class="transfer-dialog__header">
    <div class="transfer-dialog__heading">
      <span class="transfer-dialog__title-icon" aria-hidden="true">
        <i-tabler name="arrows-exchange" class="icon-20"></i-tabler>
      </span>
      <div>
        <h3 class="transfer-dialog__title">Realizar Transferencia Bancaria</h3>
        <p class="transfer-dialog__subtitle">
          Registra un movimiento entre cuentas registradas.
        </p>
      </div>
    </div>

    <button
      type="button"
      mat-icon-button
      mat-dialog-close
      class="transfer-dialog__close"
      aria-label="Cerrar diálogo"
    >
      <i-tabler name="x" class="icon-18"></i-tabler>
    </button>
  </div>

  <mat-dialog-content class="mat-typography transfer-dialog__content">
    <div class="transfer-dialog__field">
      <mat-label class="transfer-dialog__label">Elige la moneda</mat-label>
      <div class="monedaGroup">
        <button
          type="button"
          class="btn-moneda"
          [ngClass]="{
            selected: myForm.get('moneda')?.value === 'Soles',
            disabled: isCuentaCargoLocked
          }"
          [disabled]="isCuentaCargoLocked"
          (click)="changeMoneda('Soles')"
        >
          Soles (PEN)
        </button>
        <button
          type="button"
          class="btn-moneda"
          [ngClass]="{
            selected: myForm.get('moneda')?.value === 'Dólares',
            disabled: isCuentaCargoLocked
          }"
          [disabled]="isCuentaCargoLocked"
          (click)="changeMoneda('Dólares')"
        >
          Dólares (USD)
        </button>
      </div>
    </div>

    <div class="transfer-dialog__field">
      <mat-label class="transfer-dialog__label">Fecha de Operación</mat-label>
      <mat-form-field appearance="outline" class="w-100">
        <input
          matInput
          [matDatepicker]="dp1"
          formControlName="fechaOperacion"
          (input)="onDateChange($event, 'fechaOperacion')"
        />
        <mat-datepicker-toggle matIconSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
        <mat-hint
          *ngIf="
            getControl('fechaOperacion')?.touched &&
            getControl('fechaOperacion')?.invalid
          "
          class="error-msg"
        >
          <span
            *ngIf="getControl('fechaOperacion')?.errors?.['required']"
            class="text-error transfer-dialog__error"
          >
            Fecha de Operación es requerida.
          </span>
        </mat-hint>
      </mat-form-field>
    </div>

    <div class="transfer-dialog__field">
      <mat-label class="transfer-dialog__label">Ingresa el monto</mat-label>
      <mat-form-field appearance="outline" class="w-100">
        <input
          matInput
          formControlName="monto"
          name="monto"
          [placeholder]="placeHolderMoneda"
          (input)="onNumberInput($event)"
          required
        />
        <mat-icon matPrefix>
          <i-tabler name="cash" class="icon-20 d-flex"></i-tabler>
        </mat-icon>
        <mat-hint
          *ngIf="getControl('monto')?.touched && getControl('monto')?.invalid"
          class="error-msg"
        >
          <span
            *ngIf="getControl('monto')?.errors?.['required']"
            class="text-error transfer-dialog__error"
          >
            Monto es requerido.
          </span>
        </mat-hint>
      </mat-form-field>
    </div>

    <div class="transfer-dialog__field">
      <mat-label class="transfer-dialog__label">Elige la cuenta a cargo</mat-label>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select
          placeholder="Seleccionar Cuenta"
          formControlName="cuentaCargo"
          [disabled]="isCuentaCargoLocked"
        >
          <mat-option
            *ngFor="let objBanco of ListaBancosPorMoneda"
            [value]="objBanco"
          >
            {{ objBanco.nombre }}
          </mat-option>
        </mat-select>
        <mat-hint
          *ngIf="
            getControl('cuentaCargo')?.touched &&
            getControl('cuentaCargo')?.invalid
          "
          class="error-msg"
        >
          <span
            *ngIf="getControl('cuentaCargo')?.errors?.['required']"
            class="text-error transfer-dialog__error"
          >
            Cuenta a cargo es requerida.
          </span>
        </mat-hint>
        <mat-icon matPrefix>
          <i-tabler name="building-bank" class="icon-20 d-flex"></i-tabler>
        </mat-icon>
        <mat-icon
          *ngIf="isCuentaCargoLocked"
          matSuffix
          matTooltip="La cuenta de cargo proviene de la conciliación y no puede modificarse."
        >
          lock
        </mat-icon>
      </mat-form-field>
    </div>

    <div class="transfer-dialog__field">
      <mat-label class="transfer-dialog__label">Elige la cuenta de destino</mat-label>
      <mat-form-field appearance="outline" class="w-100">
        <mat-select
          placeholder="Seleccionar Cuenta"
          formControlName="cuentaDestino"
        >
          <mat-option *ngFor="let objBanco of ListaBancos" [value]="objBanco">
            {{ objBanco.nombre }}
          </mat-option>
        </mat-select>
        <mat-hint
          *ngIf="
            getControl('cuentaDestino')?.touched &&
            getControl('cuentaDestino')?.invalid
          "
          class="error-msg"
        >
          <span
            *ngIf="getControl('cuentaDestino')?.errors?.['required']"
            class="text-error transfer-dialog__error"
          >
            Cuenta de destino es requerida.
          </span>
        </mat-hint>
        <mat-icon matPrefix>
          <i-tabler name="building-bank" class="icon-20 d-flex"></i-tabler>
        </mat-icon>
      </mat-form-field>
    </div>

    <div class="transfer-dialog__field" *ngIf="needTipoCambio">
      <mat-label class="transfer-dialog__label">Agrega el Tipo de Cambio</mat-label>
      <mat-form-field appearance="outline" class="w-100">
        <input
          matInput
          formControlName="tipoCambio"
          name="tipoCambio"
          [placeholder]="placeHolderMoneda"
          (input)="onNumberInput($event)"
          required
        />
        <mat-icon matPrefix>
          <i-tabler name="cash" class="icon-20 d-flex"></i-tabler>
        </mat-icon>
        <mat-hint
          *ngIf="
            getControl('tipoCambio')?.touched &&
            getControl('tipoCambio')?.invalid
          "
          class="error-msg"
        >
          <span
            *ngIf="getControl('tipoCambio')?.errors?.['required']"
            class="text-error transfer-dialog__error"
          >
            Tipo de Cambio es requerido.
          </span>
        </mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="transfer-dialog__actions">
    <button
      type="button"
      mat-flat-button
      color="primary"
      class="transfer-dialog__submit"
      (click)="onSave()"
      [disabled]="myForm.invalid || loading"
    >
      <div
        *ngIf="loading"
        class="d-flex align-items-center justify-content-center white-spinner transfer-dialog__loading"
      >
        <span>Guardando</span>
        <div class="separador"></div>
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <span *ngIf="!loading">Confirmar</span>
    </button>
  </mat-dialog-actions>
</form>
